<template>
    <InputRangeTwoKnobbedWithInputsContainer>
        <InputRangeSegmented
            v-bind="props"
            v-model="model"
        />

        <InputRangeTextInputs
            v-bind="props"
            v-model="model"
        />
    </InputRangeTwoKnobbedWithInputsContainer>
</template>

<script lang="ts" setup>
import { useModel } from 'vue'

import { defaults } from '@/components/ui/inputs/range/input-range-two-knobbed-props.ts'

import InputRangeTextInputs from '@/components/ui/inputs/range/InputRangeTextInputs.vue'
import InputRangeTwoKnobbedWithInputsContainer from '@/components/ui/inputs/range/InputRangeTwoKnobbedWithInputsContainer.vue'
import InputRangeSegmented from '@/components/ui/inputs/range/InputRangeSegmented.vue'
import type { SegmentedProps } from './input-range-segmented'

const props = withDefaults(defineProps<SegmentedProps>(), defaults)

const model = useModel(props, 'modelValue')
</script>
